import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {DirectiveOptions} from 'vue/types/options';

gsap.registerPlugin(ScrollTrigger);

const enterUpFade: DirectiveOptions = {
    inserted: (el) => {
        const triggerSelector = el.dataset.triggerSelector || '.container';
        let trigger: HTMLElement;
        if (triggerSelector === 'self') {
            trigger = el;
        } else {
            trigger = el.closest(triggerSelector) || el;
        }

        gsap.from(
            el,
            {
                y: '25%',
                opacity: 0,
                scrollTrigger: {
                    trigger,
                    start: 'top 100%',
                    end: 'top 90%',
                    scrub: 1,
                    markers: false,

                },
            },
        );
    },
};
export default enterUpFade;
